import api from './api'

export default {
  create(data) {
    return api.post('/stations', data)
  },
  powerAndInsolation(id, data) {
    return api.post(`/stations/powers-and-insolation/${id}`, data)
  },
  edit(id, data) {
    return api.put(`/stations/${id}`, data)
  },
  saveRestrictions(data) {
    return api.post('/restrictions', data)
  },
  findRestrictions() {
    return api.get('/restrictions')
  },
  findStationRestriction(id) {
    return api.get(`/restriction/${id}`)
  },
  findRestrictionHistory() {
    return api.get('/restriction-history')
  },
  filterRestrictionHistory(data) {
    return api.post('/restriction-history', data)
  },
  getStationPowerByMoment(data) {
    return api.post('/stations/power-by-moment', data)
  },
  getStationPowersByMoment(data) {
    return api.post('/stations/powers-by-moment', data)
  },
  findRestrictable() {
    return api.get('/restrictable')
  },
  findPowerTypeControl(id) {
    return api.get(`/power-control-type/${id}`)
  },
  setPowerTypeControl(id, type) {
    return api.get(`/set-power-control-type/${id}/${type}`)
  },
  findAll() {
    return api.get('/stations')
  },
  findOne(id) {
    return api.get(`/stations/${id}`)
  },
  lastData(id) {
    return api.get(`/stations/current-data/${id}`)
  },
  liveData(id) {
    return api.get(`/stations/live-data/${id}`)
  },
  saveForecast(id, data) {
    return api.put(`/stations/forecast/${id}`, data)
  },
  saveAskoe(id, data) {
    return api.put(`/stations/asked/${id}`, data)
  },
  production(id) {
    return api.get(`/stations/production/${id}`)
  },
  updateProduction(id, data) {
    return api.post(`/stations/update-production/${id}`, data)
  },
  fetchDevices(id) {
    return api.get(`/devices/by-station/${id}`)
  },
  forecastComparison(id) {
    return api.get(`/stations/forecast-comparison/${id}`)
  },
  forecastPowerComparison(id) {
    return api.get(`/stations/forecast-power-comparison/${id}`)
  },
  cameraLastSnapshot(id) {
    return api.get(`/camera/last-frame/${id}`)
  },
  fetchData(id, params) {
    return api.post(`/station-data/${id}`, params)
  },
  fetchProduction(id, params) {
    return api.post(`/station-production/${id}`, params)
  },
  gridInverters(id) {
    return api.get(`/stations/grid-inverters/${id}`)
  }
}
